'use client'

import { createContext, useContext, useState } from 'react'

import { log } from '@src/utils/log.util'

/**
 * Syncs multiple click actions on the same page.
 * This is useful for preventing multiple click actions from being triggered at the same time.
 **/
export const ClickActionContext = createContext({
  isLoadingAnyAction: false,
  setIsLoadingAnyAction: (_isLoading: boolean) => {},
})

export function ClickActionProvider(props: { children: React.ReactNode }) {
  const [isLoadingAnyAction, setIsLoadingAnyAction] = useState(false)
  return (
    <ClickActionContext.Provider value={{ isLoadingAnyAction, setIsLoadingAnyAction }}>
      {props.children}
    </ClickActionContext.Provider>
  )
}

export function useClickActionContext() {
  try {
    return useContext(ClickActionContext)
  } catch (error) {
    log.error('useClickActionContext must be used within a ClickActionProvider')
    return {
      isLoadingAnyAction: false,
      setIsLoadingAnyAction: (_isLoading: boolean) => {},
      pdpViewModel: null,
    }
  }
}
